const childRoutes = (prop) => [
    // Expenditure Report
    {
        path: 'expenditure-report',
        name: prop + '.expenditure_report',
        meta: { auth: true },
        component: () => import('../pages/expenditure-report/List.vue')
    },
    // Service Recipient Report
    {
        path: 'service-recipient-report',
        name: prop + '.service_recipient_report',
        meta: { auth: true },
        component: () => import('../pages/service-recipient-report/List.vue')
    },
     // Approved GO Report
     {
        path: 'approved-go-report',
        name: prop + '.approved_go_report',
        meta: { auth: true },
        component: () => import('../pages/approved-go-report/List.vue')
    },
     // Pending GO Report
     {
        path: 'pending-go-report',
        name: prop + '.pending_go_report',
        meta: { auth: true },
        component: () => import('../pages/pending-go-report/List.vue')
    },
    // Application Status Report
    {
        path: 'application-status-report',
        name: prop + '.application_status_report',
        meta: { auth: true },
        component: () => import('../pages/application-status-report/List.vue')
    },
    // Service Tracker
    {
        path: 'service-tracker',
        name: prop + '.service_tracker',
        meta: { auth: true },
        component: () => import('../pages/service-tracker/List')
    },
    // pending payment report
    {
        path: 'pending-payment-report',
        name: prop + '.pending_payment_report',
        meta: { auth: true },
        component: () => import('../pages/pending-payment-report/List.vue')
    },
    // Other On-Demand Report
    {
        path: 'other-on-demand-report',
        name: prop + '.other_on_demand_report',
        meta: { auth: true },
        component: () => import('../pages/on-demand-report/List.vue')
    },
    // CDivision apitation Grant Report
    {
        path: 'division-capitation-grant-report',
        name: prop + '.division_capitation_grant_report',
        meta: { auth: true },
        component: () => import('../pages/division-capitation-grant-report/List.vue')
    },
    // Capitation Grant Received Report
    {
        path: 'capitation-grant-received-report',
        name: prop + '.capitation_grant_received_report',
        meta: { auth: true },
        component: () => import('../pages/capitation-received-report/List.vue')
    },
    // Orphanage List
    {
        path: 'orphanage-list-all',
        name: prop + '.orphanage_list_all',
        meta: { auth: true },
        component: () => import('../pages/orphanage-list-all/List.vue')
    },
    {
        path: 'orphanage-all-student-list',
        name: 'orphanage_all_student_list',
        meta: { auth: true },
        component: () => import('../pages/orphanage-list-all/Student.vue')
    },
    {
        path: 'orphanage-grant-report',
        name: prop + '.orphanage_grant_report',
        meta: { auth: true },
        component: () => import('../pages/orphanage-grant-report/ApplicationsInfo.vue')
    },
    {
        path: 'ministry-proposes-allocation-capitation-grant',
        name: prop + '.ministry_proposes_allocation_capitation_grant',
        meta: { auth: true },
        component: () => import('../pages/ministry-proposes-allocation-capitation-grant/ReportInfo.vue')
    },
    {
        path: 'medical-treatment-upazilla-disease-report',
        name: prop + '.medical_treatment_upazilla_disease_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-upazilla-disease-report/List.vue')
    },
    {
        path: 'orphanage-applications-info',
        name: prop + '.orphanage_applications_info',
        meta: { auth: true },
        component: () => import('../pages/orphanage-list-all/ApplicationsInfo.vue')
    },
    {
        path: 'summary-sheet',
        name: prop + '.summary_sheet',
        meta: { auth: true },
        component: () => import('../pages/summary-sheet/summarySheet.vue')
    },
    {
        path: 'summary-sheet-new-report',
        name: prop + '.summary_sheet_new_report',
        meta: { auth: true },
        component: () => import('../pages/summary-sheet-new-report/summarySheet.vue')
    },
    {
        path: 'orphanage-list',
        name: prop + '.orphanage_list',
        meta: { auth: true },
        component: () => import('../pages/orphanage-list/List.vue')
    },
    {
        path: 'medical-treatment-report',
        name: prop + '.medical_treatment_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-report/List.vue')
    },
    {
        path: 'medical-treatment-application-summary-report',
        name: prop + '.medical_treatment_application_summary_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-application-summary-report/List.vue')
    },
    {
        path: 'medical-treatment-all-summary-report',
        name: prop + '.medical_treatment_all_summary_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-all-summary-report/List.vue')
    },
    {
        path: 'medical-treatment-disbursement-duplicate-report',
        name: prop + '.medical_treatment_disbursement_duplicate_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-disbursement-report/List.vue')
    },
    {
        path: 'special-grant-report',
        name: prop + '.special_grant_report',
        meta: { auth: true },
        component: () => import('../pages/special-grant-report/List.vue')
    },
    {
        path: 'medical-treatment-disbursement-report',
        name: prop + '.medical_treatment_disbursement_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-disbursement-report/List.vue')
    },
    {
        path: 'medical-treatment-expense-reports',
        name: prop + '.medical_treatment_expense_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-hospital-report/List.vue')
    },
    {
        path: 'medical-treatment-summary-report',
        name: prop + '.medical_treatment_summary_report',
        meta: { auth: true },
        component: () => import('../pages/med-treatment-summary-report/List.vue')
    },
    {
        path: 'orphanage-student-list',
        name: 'student_list',
        meta: { auth: true },
        component: () => import('../pages/orphanage-list/Student.vue')
    },
    {
        path: 'monthly-progress-report',
        name: 'monthly_progress_report',
        meta: { auth: true },
        component: () => import('../pages/monthly-progress-report/List.vue')
    },
    {
        path: 'medical-assistance-patient-report',
        name: 'medical_assistance_patient_report',
        meta: { auth: true },
        component: () => import('../pages/patient-report-medical-assistance/List.vue')
    },
    {
        path: 'disease-wise-beneficiary-report',
        name: 'disease_wise_beneficiary_report',
        meta: { auth: true },
        component: () => import('../pages/disease-wise-beneficiary-report/List.vue')
    },
    // application sending list realted route
    {
        path: 'upazila-to-district-sending-list',
        name: 'upazila_to_district_sending_list',
        meta: { auth: true },
        component: () => import('../pages/application-sending-list/upazila-to-district/List.vue')
    },
    {
        path: 'district-to-division-sending-list',
        name: 'district_to_division_sending_list',
        meta: { auth: true },
        component: () => import('../pages/application-sending-list/district-to-division/List.vue')
    },
    {
        path: 'division-directorate-sending-list',
        name: 'division_directorate_sending_list',
        meta: { auth: true },
        component: () => import('../pages/application-sending-list/division-to-directorate/List.vue')
    },
    {
        path: 'directorate-to-ministry-list',
        name: 'directorate_to_ministry_list',
        meta: { auth: true },
        component: () => import('../pages/application-sending-list/directorate-to-ministry/List.vue')
    },
    {
        path: 'ministry-to-go-list',
        name: 'ministry_to_go_list',
        meta: { auth: true },
        component: () => import('../pages/application-sending-list/ministry-to-go/List.vue')
    },
    {
        path: 'rehabilitation-burn-disabled-victims',
        name: 'rehabilitation_burn_disabled_victims',
        meta: { auth: true },
        component: () => import('../pages/rehabilitation-burn-disabled-victims/List.vue')
    },
    {
        path: 'settlement-distribution-progress-report',
        name: 'settlement_distribution_progress_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-settlement-distribution-progress-report/List.vue')
    },
    {
        path: 'medical-treatment-hospital-application-report',
        name: 'medical_treatment_hospital_application_report',
        meta: { auth: true },
        component: () => import('../pages/medical-treatment-hospital-application-report/List.vue')
    },
    {
        path: 'district-wise-budget-allocation-report',
        name: prop + '.district_wise_budget_allocation_report',
        meta: { auth: true },
        component: () => import('../pages/district-wise-budget-allocation-report/List.vue')
    },
    {
        path: 'national-level-grant-report',
        name: prop + '.national_level_grant_report',
        meta: { auth: true },
        component: () => import('../pages/national-level-grant-report/List.vue')
    },
    {
        path: 'patient-welfare-association-report',
        name: prop + '.patient_welfare_association_report',
        meta: { auth: true },
        component: () => import('../pages/patient-welfare-association-report/List.vue')
    },
    {
        path: 'coordination-council-report',
        name: prop + '.coordination_council_report',
        meta: { auth: true },
        component: () => import('../pages/coordination-council-report/List.vue')
    },
    {
        path: 'correction-of-offender-report',
        name: prop + '.correction_of_offender_report',
        meta: { auth: true },
        component: () => import('../pages/correction-of-offender-report/List.vue')
    },
    {
        path: 'registered-general-voluntary-organization-report',
        name: prop + '.registered_general_voluntary_organization_report',
        meta: { auth: true },
        component: () => import('../pages/registered-general-voluntary-organization-report/List.vue')
    }
]
const routes = [{
    path: '/grant-allowance-service/performance-monitoring',
    name: 'grant_allowance_service.performance_monitoring',
    component: () => import('@/layouts/GrantAllowanceLayout.vue'),
    meta: { auth: true },
    children: childRoutes('grant_allowance_service.performance_monitoring')
}]
export default routes
